import React from 'react'
import {Carousel} from 'react-responsive-carousel'
const Servie = () => {
  return (
    <div>
        <Carousel>
            <div>
                <img src="https://wallpaperaccess.com/full/516010.jpg" alt="" srcset="" />
                <p>hello</p>
            </div>
            <div>
                <img src="https://wallpaperaccess.com/full/516010.jpg" alt="" srcset="" />
                <p>hello-moto</p>
            </div>
        </Carousel>
    </div>
  )
}

export default Servie